module.exports = __webpack_public_path__ + "img/to-apartment.08b92afa.png";